import { createStyle } from "~/common/utils/create-style";

const sideNavStyle = createStyle({
  slots: {
    container: [
      "flex flex-col justify-between h-[calc(100vh-6.8rem)] lg:h-screen p-16",
      "lg:static absolute top-[6.8rem] z-999 w-full bg-surface-20",
    ],
    workspaceDropdown: "hidden lg:block",
    navigationContent: "flex grow flex-col gap-16",
    actionButtons:
      "flex flex-row justify-between border-b border-b-border-opacity-10 pb-16",
    list: "flex flex-col gap-4",
    navigationSections: "flex grow flex-col gap-16",
  },
})();

export { sideNavStyle };
